import { apiRequest } from "../../Bedrooms/utils/http";

// In-app documentation, served by the API (blissdatabase docs/in-app). The
// server decides which pages this account may see - by instance, release and
// access level - so nothing here filters anything.
const helpApi = {
  // [{ slug, title, section, audience, sortOrder }], already in reading order.
  getContents: () => apiRequest("/api/docs").then((rows) => rows || []),

  // { slug, title, section, audience, body, updatedAt }. 404 for a page that
  // does not exist and for one this account may not see.
  getPage: (slug) => apiRequest(`/api/docs/pages/${encodeURIComponent(slug)}`),

  // [{ slug, title, section, snippet }]; the server ignores fewer than 2 characters.
  search: (q, signal) => apiRequest(`/api/docs/search?q=${encodeURIComponent(q)}`, { signal }).then((rows) => rows || []),
};

export default helpApi;
